import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RequisitionDataService } from '../../data-services/requisition.service';
import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { SecurityUser } from '../../security/security.service';
import { Dialog } from 'primeng/dialog';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';

@Component({
  selector: 'app-requisition-list',
  templateUrl: './requisition.list.html',
  imports: [Dialog, CommonModule, TableModule]
})
export class RequisitionListComponent implements OnInit {
  currentUser: SecurityUser = new SecurityUser();
  isAuthenticated: boolean;

  constructor(private requisitionDataService: RequisitionDataService,
    private router: Router
    ) {}

  requisitions;
  statuses: SelectItem[] = [];
  facilities: SelectItem[] = [];
  testNames: SelectItem[] = [];
  totalRecords: number;
  cols: any[];
  loading: boolean;
  selectedStatus: SelectItem;
  globalFilter: string = '';
  showDetailDialog: boolean = false;
  detailId: number = 0;

  async ngOnInit() {

    this.cols = [
      { field: 'Accession', header: 'SID', filter: '', sortable: true, width: '8%'  },
      { field: 'PatientName', header: 'Patient Name', filter: '', sortable: true, width: '10%'  },
      { field: 'BirthDate', header: 'DOB', filter: '', sortable: true, width: '6%'  },
      { field: 'ClientName', header: 'Client', filter: '', sortable: true, width: '10%'  },
      { field: 'RequisitionTests', header: 'Lab Tests', filter: '', sortable: false, width: '15%'  },
      { field: 'SpecimenTypeCode', header: 'Specimen Type', filter: '', sortable: true, width: '6%'  },
      { field: 'DateOfService', header: 'Collection Date', filter: '', sortable: true, width: '8%'  },
      { field: 'DateReceived', header: 'Received Date', filter: '', sortable: true, width: '8%'  },
      { field: 'Status', header: 'Status', filter: '', sortable: true, width: '6%'  },
      { field: 'StatusDate', header: 'Status Date', filter: '', sortable: true, width: '8%'  },
      { field: 'RequisitionExceptions', header: 'Exceptions', filter: '', sortable: false, width: '15%'  }
    ];
    this.loading = true;

  }

  public handleSearchKey(event, reqlist) {
    this.addFilter('global', event.target.value);
    if (event.keyCode == 13) {
      reqlist.filter('', 'Accession', 'equals');
      event.preventDefault();
    }
  }

  public loadRequisitionsLazy(event: LazyLoadEvent) {
    this.loading = true;
    this.requisitionDataService.getList(event.first, event.rows, event.sortField, event.sortOrder, this.getFilters()).subscribe((data: any) => {
      this.totalRecords = data.totalRows;
      this.requisitions = data.rows;
      this.loading = false;
    });
  }

  public addFilter(key: string, value: string) {
    if (key == 'global') {
      this.globalFilter = value;
    } else {
      this.cols.forEach(col => {
        if (col.field == key) {
          col.filter = value;
          return;
        }
      });
    }
  }

  public filterKeyPress(pressedKey, reqlist) {
    if (pressedKey.key === "Enter") {
      reqlist.filter('', 'Accession', 'equals');
    }
  }

  public getFilters() {
    var filters: any[] = [];
    this.cols.forEach(col => {
      if (col.filter.length > 0) {
        filters.push(col);
      }
    });

    if (this.globalFilter.length > 0) {
      filters.push({ field: 'global', header: 'global', filter: this.globalFilter });
    }

    return JSON.stringify(filters);
  }

  showDetail(accession) {
    this.router.navigate(['/package-list/' + accession]);
  }

  hideDetail() {
    this.showDetailDialog = false;
    this.detailId = 0;
  }

}
